<template>
  <v-app>
    <div class="container">

      <!-- Header -->
      <header-simple></header-simple>

      <!-- Contents -->
      <div class="contents">

        <!-- Forgot username -->
        <div v-if="step=='forgot-username'">
          <form-forgot-username></form-forgot-username>
        </div>

        <!-- Forgot password -->
        <div v-else-if="step=='forgot-password'">
          <form-forgot-password></form-forgot-password>
        </div>

        <!-- Forgot email -->
        <div v-else-if="step=='forgot-email'">
          <form-forgot-email></form-forgot-email>
        </div>

        <!-- Login -->
        <div v-else>
          <div class="header-title">
            {{ $t('login.login') }}
          </div>
          <form-login></form-login>
        </div>

      </div>

      <!-- Footer -->
      <footer-simple></footer-simple>

    </div>

  </v-app>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "Login"
    }
  },

  computed: {
    step() {
      return this.$route.query.step
    },
  }
}
</script>

<style scoped>
  .container {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .contents {
    display: flex;
    flex-direction: column;
    background-color: #fff;
    max-width: 450px;
    width: 100%;
    border: 1px solid #dadce0;
    border-radius: 8px;
    padding: 22px 40px 38px;
    margin-top: 60px;
  }

  .header-title {
    padding: 20px 0;
    font-size: 28px;
    font-weight: 700;
    text-align: center;
  }

  @media (min-height: 700px) {
    .container {
      justify-content: center;
    }

    .contents {
      margin-top: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/spa/common/Login.vue